import { trackTypeUrlParamsMap } from '@/entities/tracks'
import { ROUTES } from '@/shared/config'
import { ContentWrapper, HeaderContent } from '@/shared/ui'
import { TrackForm } from '@/widgets/TrackForm'
import { Breadcrumb, Layout } from 'antd'
import { Link, useSearchParams } from 'react-router-dom'

export const TrackCreatePage = () => {
  const [searchParams] = useSearchParams()
  const trackTypeParam = searchParams.get('tracktype')?.toLowerCase()
  const trackType = trackTypeParam
    ? trackTypeUrlParamsMap[trackTypeParam]
    : undefined

  return (
    <Layout>
      <HeaderContent
        breadcrumbSlot={
          <Breadcrumb
            items={[
              { title: 'Контент' },
              { title: <Link to={ROUTES.AUDIO.ROOT}>Аудиофайлы</Link> },
              {
                title: 'Создание записи',
              },
            ]}
          />
        }
        title="Создание записи"
        description="Раздел предоставляет возможность добавлять новый контент в каталог и управлять его параметрами"
      />

      <ContentWrapper>
        <TrackForm initialTrackType={trackType} />
      </ContentWrapper>
    </Layout>
  )
}
